View = require 'view'
templates = require 'views/internal/templates'
{ locales } = require 'db/locale-information'
Language = require 'lib/language'

module.exports = class PowerUpItemDetailsView extends View
  initialize: ({ @powerUp, @isGrandfathered }) ->
    return

  getViewTitle: -> @powerUp.displayName

  render: ->

    data =
      about: templates.fill(@powerUp.aboutTemplate)
      showScreenshots: Language.matches(locales[0], 'en')
      screenshots: @powerUp.screenshots
      displayName: @powerUp.displayName
      isGrandfathered: @isGrandfathered

    @$el.html(
      templates.fill(
        'power_up_item_details'
        data
      )
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/power-up-item-details-view.coffee